import React, { useEffect, useState } from 'react';
import {
    Avatar,
    Button,
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
    Tooltip
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useDispatch } from 'react-redux';
import lock from 'src/pages/common/lock.png';
import { checkPermission } from 'src/utils/permission';
import {
    fetchVehicleVariant
} from 'src/features/staticDataSlice';
import VehicleVariantModel from 'src/pages/VehichleVariant/VehicleVariantModel';


const StyledInputLabel = styled(InputLabel)(({ theme, error }) => ({
    color: error ? theme.palette.error.main : 'inherit',
    background: '#fff',
    padding: '0 4px'
}));

function VehicleVarient({
    tableListDatas,
    index,
    productId,
    saveRow,
    getValidationMessage,
    label,
    riskFactorname = '',
    apiUrl = null,
    vehicleModelData = [],
    vehicleVariantData = [],
    setVehicleVariantData = (data) => { },
    handleChange
}) {

    const dispatch = useDispatch();
    const [openCreateModal, setOpenCreateModal] = useState(false);
    const [newValue, setNewValue] = useState('');
    const [riskFactorCreatePermission, setRiskFactorCreatePermission] = useState(false);
    const [vehicleModelId, setVehicleModelId] = useState(null);
    const [vehicleVariantDataList, setVehicleVariantDataList] = useState([]);
    useEffect(() => {
        if (newValue !== undefined && newValue !== '') {
            handleChange('vehicleVariant', index, newValue);
            saveRow(index);
        } else if (newValue === undefined) {
            handleChange('vehicleVariant', index, '');
        }
    }, [newValue]);

    // Set variant list for index
    useEffect(() => {
        setVehicleVariantDataList(vehicleVariantData[index] || []);
    }, [vehicleVariantData, index]);

    // Get model ID from model name and fetch variants if not present
    useEffect(() => {
        const modelName = tableListDatas[index]?.vehicleModel;
        const modelList = vehicleModelData[index] || [];
        const modelInfo = modelList.find(model => model.name === modelName);
        if (modelInfo?.id) {
            setVehicleModelId(modelInfo.id);

            if (!vehicleVariantData[index] || vehicleVariantData[index].length === 0) {
                fetchVehicleVariant(modelInfo.id, 'vehichle/listVehicleVariant').then(data => {
                    setVehicleVariantData(prev => {
                        const updated = [...prev];
                        updated[index] = data;
                        return updated;
                    });
                });
            }
        }
    }, [vehicleModelData, index]);

    useEffect(() => {
        checkPermission(apiUrl.permission_key, 'Create').then((permission) => {
            setRiskFactorCreatePermission(permission);
        });
    }, []);

    const handleClose = () => {
        setOpenCreateModal(false);
        if (vehicleModelId) {
            fetchVehicleVariant(vehicleModelId, 'vehichle/listVehicleVariant').then(data => {
                setVehicleVariantData(prev => {
                    const updated = [...prev];
                    updated[index] = data;
                    return updated;
                });
            });
        }
    };

    useEffect(() => {
        if (newValue) {
            handleChange(apiUrl.formKey, index, newValue);
            saveRow(index);
        }
    }, [newValue]);

    return (
        <>
            <FormControl fullWidth size="small">
                <StyledInputLabel id={`select-label-${apiUrl.formKey}`} error={false}>
                    {label}
                </StyledInputLabel>
                <Select
                    labelId={`select-label-${apiUrl.formKey}`}
                    id={`select-${apiUrl.formKey}`}
                    value={tableListDatas[index]?.[apiUrl.formKey] || ''}
                    onChange={(event) => {
                        const value = event.target.value;
                        handleChange(apiUrl.formKey, index, value);
                        setNewValue('');
                        setTimeout(() => {
                            if (document.activeElement instanceof HTMLElement) {
                                document.activeElement.blur();
                            }
                        }, 0);
                    }}
                    style={{ width: '100%', minWidth: 180 }}
                    error={false}
                >
                    {vehicleVariantDataList.map((variant) => (
                        <MenuItem key={variant.name} value={variant.name}>
                            {variant.name}
                        </MenuItem>
                    ))}
                    <Tooltip
                        title={
                            riskFactorCreatePermission ? (
                                ''
                            ) : (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Avatar
                                        alt=""
                                        src={lock}
                                        sx={{ width: 24, height: 24, marginRight: 1 }}
                                    />
                                    You don't have permission to add Risk Factor
                                </div>
                            )
                        }
                    >
                        <Button
                            variant="text"
                            onClick={() => {
                                if (riskFactorCreatePermission) {
                                    setOpenCreateModal(true);
                                }
                            }}
                            sx={{ color: riskFactorCreatePermission ? '#5569ff' : 'grey' }}
                        >
                            Add More
                        </Button>
                    </Tooltip>
                </Select>
                <FormHelperText error={false}>
                    {/* {getValidationMessage(formik, index, apiUrl.formKey)} */}
                </FormHelperText>
            </FormControl>

            {openCreateModal && (
                <VehicleVariantModel
                    handleClose={handleClose}
                    modelId={vehicleModelId}
                    setNewValue={setNewValue}
                />
            )}
        </>
    );
}

export default VehicleVarient;
